<!-- TEMPLATE -->
<template>
  <div :class="deanSectionDividerClass">
    <span class="dean-section-divider-content">
      <slot></slot>
      <transition name="bounce" mode="out-in" appear>
        <span class="action" v-if="buttons">
          <div
            v-if="largeButtons"
            v-for="button in buttons"
            class="action-button"
            :key="button.name"
          >
          <div class="action-button-inner"
            @click="buttonClicked(button)">
            <dean-icon
              class="action-button-inner-icon"
              :glyph="button.icon">
            </dean-icon>
            <p>{{ button.label }}</p>
          </div>
          </div>
          <div
            v-if="!largeButtons"
            v-for="button in buttons"
            class="action-button"
            :key="button.name"
          >
            <dean-tooltip
              class="action-button-inner"
              @click.native="buttonClicked(button)"
            >
              <dean-icon
                slot="activator"
                class="action-button-inner-icon"
                :glyph="button.icon"
              >
              </dean-icon>
              {{ button.label }}
            </dean-tooltip>
          </div>
        </span>
      </transition>
    </span>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

// COMPONENTS
import deanIcon from './deanIcon.vue';
import deanTooltip from './deanTooltip.vue';

@Component({
  components: {
    deanIcon,
    deanTooltip
  }
})
export default class deanSectionDivider extends Vue {
  // PROPS
  @Prop({ default: false }) sidemenu!: boolean;
  @Prop() buttons!: Array<any>;
  @Prop({ default: false }) largeButtons!: boolean;
  @Prop() small!: boolean;

  // COMPUTED
  get deanSectionDividerClass() {
    let value = 'dean-section-divider';
    if (this.sidemenu) value += ` dean-section-divider-sidemenu`;
    if (this.small) value += ` dean-section-divider-small`;
    return value;
  }

  // METHOD
  buttonClicked(data: object) {
    this.$emit('button-click', data);
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
/* Import */
@import '../scss/vars';

// DEAN SECTION DIVIDER
.dean-section-divider {
  padding: 5px 10px 5px 10px;
  width: 100%;
  font-size: $font-heading-small;
  > span {
    min-height: 51px;
    position: relative;
    @include display-flex();
    justify-content: space-between;
    align-items: flex-end;
    padding: 10px 0px 10px 10px;
    text-align: left;
    font-weight: 700;
    color: black;
    border-bottom: 1px solid var(--color-light-shade-2, $color-light-shade-2);
    /*
    &:after {
      position: absolute;
      bottom: 0px;
      content: '';
      min-width: 35px;
      min-height: 5px;
      background: var(--color-secondary, $color-secondary);
    }
    */
  }
}

.dean-section-divider-small {
  > span {
    font-size: 12pt;
     &:after {
      background: none;
    }
  }
}

.dean-section-divider-sidemenu {
  > span {
    border-bottom: 1px solid var(--color-light, $color-light);
  }
}
.action {
  @include display-flex();

  .action-button {
    padding-left: 10px;

    .action-button-inner {
      @include display-flex();
      justify-content: flex-start;
      align-items: center;
      height: 30px;
      padding: 6px;
      background: var(--color-light-shade-2, $color-light-shade-2);
      fill: var(--color-link, $color-link);
      @include border-radius(5px);
      cursor: pointer;
      transition: 0.8s;
      p {
        padding: 0px 0px 0px 10px;
        font-style: normal;
        font-weight: 500;
        text-transform: initial;
        font-size: 18px;
        color: var(--color-link, $color-link);
      }

      @media #{$small-only} {
        p {
          display: none;
        }
      }

      &:hover {
        fill: var(--color-link-shade-1, $color-link-shade-1);
        background: var(--color-light, $color-light);
      }

      .action-button-inner-icon {
        height: 100%;
        max-width: 100%;
      }
    }
  }
}

/*
// THEMED
.themed {
  // DEAN SECTION DIVIDER
  .dean-section-divider {
    // THEMING MIXIN
    // @include themify($themes) {
      > span {
        color: white;
        border-bottom: 1px solid var(--color-light, $color-light);
      }
    // }
  }
}
*/
</style>
